import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL

import generals from '@/common-vue/mixins/generals'
export default {
	namespaced: true,
	state: {
		model_name: 'current_acount',

		from_model_name: 'client',

		models: [],
		model: {},
		to_show: [],

		months_ago: 1,
		cantidad_movimientos: 10,
		from_credit_account: {},
		from_model: {},
		selected: [],
		to_show_payment_methods: {},
		to_pay: null,

		delete: null,
		delete_image: null,

		/**
		 * Checkbox del modal de borrado de movimiento CC: enviar `compensar_caja` en DELETE.
		 */
		compensar_caja_delete: true,

		display: 'table',

		loading: false,
	},
	mutations: {
		/**
		 * Guarda el valor del checkbox antes de borrar un movimiento de cuenta corriente.
		 *
		 * @param {Object} state Estado del módulo.
		 * @param {boolean} value Checkbox compensar caja.
		 * @returns {void}
		 */
		setCompensarCajaDelete(state, value) {
			state.compensar_caja_delete = value
		},
		setFromModelName(state, value) {
			state.from_model_name = value 
		},
		setLoading(state, value) {
			state.loading = value
		},
		setModel(state, value) {
			if (value.model) {
				state.model = value.model
				if (value.properties.length) {
					value.properties.forEach(prop => {
						state.model[prop.key] = prop.value 
					})
				}
			} else {
				let obj = {
					id: null
				}
				require(`@/models/${state.model_name}`).default.properties.forEach(prop => {
					obj[prop.key] = prop.value 
				})
				if (value.properties.length) {
					value.properties.forEach(prop => {
						obj[prop.key] = prop.value 
					})
				}
				state.model = obj
			}
		},
		setModels(state, value) {
			if (value) {
				state.models = value
			} else {
				state.models = []
			}
		},
		setToShow(state, value) {
			if (value) {
				state.to_show = value
			} else {
				state.to_show = state.models.slice(0, 20)
			}
		},
		addToShow(state, value) {
			state.to_show = state.to_show.concat(state.models.slice(state.to_show.length, state.to_show.length + 20))
		},
		set_cantidad_movimientos(state, value) {
			state.cantidad_movimientos = value 
		},
		setMonthsAgo(state, value) {
			state.months_ago = value 
		},
		setFromModel(state, value) {
			state.from_model = value 
		},
		set_from_credit_account(state, value) {
			state.from_credit_account = value  
		},
		setSelected(state, value) {
			state.selected = value 
		},
		setToShowPaymentMethods(state, value) {
			state.to_show_payment_methods = value 
		},
		setToPay(state, value) {
			state.to_pay = value 
		},
		add(state, value) {
			let index = state.models.findIndex(item => {
				return item.id == value.id
			})
			if (index == -1) {
				state.models.unshift(value)
			} else {
				state.models.splice(index, 1, value)
			}
		},
		setDelete(state, value) {
			state.delete = value
		},
		delete(state) {
			let index = state.models.findIndex(model => {
				return model.id == state.delete.id
			})
			state.models.splice(index, 1)
		},
		setDeleteImage(state, value) {
			state.delete_image = value
		},
		deleteImage(state, value) {
			let index = state.models.images.findIndex(model => {
				return model.id == state.delete.id
			})
			state.models.splice(index, 1)
		},
		setDisplay(state, value) {
			state.display = value 
		},
		incrementFilterPage(state) {
			state.filter_page++
		},
		setFilterPage(state, value) {
			state.filter_page = value 
		},
		setTotalFilterPages(state, value) {
			state.total_filter_pages = value 
		},
		setTotalFilterResults(state, value) {
			state.total_filter_results = value 
		},
		addFiltered(state, value) {
			state.filtered = state.filtered.concat(value)
		},
		setLoadingFiltered(state, value) {
			state.loading_filtered = value 
		},
	},
	actions: {
		getModels({ commit, state }) {
			commit('setLoading', true)
			// return axios.get(`/api/${generals.methods.routeString(state.model_name)}/${state.from_model_name}/${state.from_model.id}/${state.months_ago}`)
			return axios.get(`/api/${generals.methods.routeString(state.model_name)}/${state.from_credit_account.id}/${state.cantidad_movimientos}`)
			.then(res => {
				commit('setLoading', false)
				commit('setModels', res.data.models)
				commit('setToShow')
			})
			.catch(err => {
				commit('setLoading', false)
				console.log(err)
			})
		},
		delete({ commit, state }) {
			return axios.delete(`/api/${generals.methods.routeString(state.model_name)}/${state.from_model_name}/${state.delete.id}`, {
				params: {
					compensar_caja: state.compensar_caja_delete ? 1 : 0,
				},
			})
				.then(() => {
					commit('delete')
				})
				.catch((err) => {
					console.log(err)
					return Promise.reject(err)
				})
		},
		deleteImage({ commit, state }) {
			return axios.delete(`/api/${generals.methods.routeString(state.model_name)}/image/${state.delete_image.id}`)
			.then((res) => {
				commit('add', res.data.model)
			})
			.catch((err) => {
				console.log(err)
			})
		},
	},
}
